import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import type {
  ClinicPhysicianResponse,
  MissedVisitDataCreate,
} from '../../services/api/types.gen';
import { MissedVisitForm } from './MissedVisitForm';

export interface MarkVisitMissedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSaving: boolean;
  physicians: ClinicPhysicianResponse[];
  onSave: (payload: MissedVisitDataCreate) => Promise<void>;
}

/** Create-mode wrapper around MissedVisitForm for the "Mark as Missed" action. */
export const MarkVisitMissedDialog: React.FC<MarkVisitMissedDialogProps> = ({
  open,
  onOpenChange,
  isSaving,
  physicians,
  onSave,
}) => (
  <Dialog
    open={open}
    onOpenChange={nextOpen => {
      if (!nextOpen && !isSaving) onOpenChange(false);
    }}
  >
    <DialogContent className='sm:max-w-lg'>
      <DialogHeader>
        <DialogTitle>Mark Visit as Missed</DialogTitle>
        <DialogDescription>
          Complete the fields below to record this as a missed visit. The visit
          will be marked non-billable.
        </DialogDescription>
      </DialogHeader>
      <MissedVisitForm
        data={null}
        isReadonly={false}
        isSaving={isSaving}
        onSave={onSave}
        physicians={physicians}
      />
    </DialogContent>
  </Dialog>
);
